export const GET_ADMIN_CATEGORIES = `
    query AdminCategories($q: ID, $page: ID) {
        adminCategories(q: $q, page: $page) {
            count
            results{
                department{
                    id
                    name
                }
                id
                isActive
                name
                subCategories {
                    id
                    name
                }
            }
            errors {
                property
                description
              }
        }
    }
`;

export const GET_DEPARTMENT_CATEGORIES = `
    query DepartmentCategories($departmentId: ID!) {
        categories(departmentId: $departmentId) {
            id
            name
        }
    }
`;

export const GET_ADMIN_SUBCATEGORIES = `
    query AdminSubCategories($q: String, $page: ID, $departmentId: ID) {
        adminSubCategories(q: $q, page: $page, departmentId: $departmentId) {
            count
            results{
                id
                isActive
                autoCloseable
                longName
                name
                sla
                category{
                    department{
                        id
                        name
                    }
                    id
                    isActive
                    name
                }
                slaCreateByEod
            }
            errors {
                property
                description
              }
        }
    }
`;

export const CREATE_CATEGORY = `
    mutation CreateCategory($name: String!, $departmentId: ID!) {
        createCategory(name: $name, departmentId: $departmentId) {
            category{
                id
            }
            errors {
                property
                description
              }
        }
    }
`;

export const UPDATE_CATEGORY = `
    mutation UpdateCategory($categoryId: ID!, $name: String!, $departmentId: ID!, $isActive: Boolean!) {
        updateCategory(categoryId: $categoryId, name: $name, departmentId: $departmentId, isActive: $isActive) {
            category{
                department{
                    id
                    name
                }
                id
                isActive
                name
                subCategories {
                    id
                    name
                }
            }
            errors {
                property
                description
              }
        }
    }
`;

export const CREATE_SUBCATEGORY = `
    mutation CreateSubCategory($name: String!, $sla: Int!, $slaCreateByEod: Int!, $categoryId: ID!) {
        createSubCategory(name: $name, sla: $sla, slaCreateByEod: $slaCreateByEod, categoryId: $categoryId) {
            subCategory{
                id
            }
            errors {
                property
                description
              }
        }
    }
`;

export const UPDATE_SUBCATEGORY = `
    mutation UpdateSubCategory($subCategoryId: ID!, $name: String!, $sla: Int!, $slaCreateByEod: Int!, $categoryId: ID!, $isActive: Boolean!, $autoCloseable: Boolean) {
        updateSubCategory(subCategoryId: $subCategoryId, name: $name, sla: $sla, slaCreateByEod: $slaCreateByEod, categoryId: $categoryId, isActive: $isActive, autoCloseable: $autoCloseable) {
            subCategory{
                    id
                    isActive
                    autoCloseable
                    longName
                    name
                    sla
                    category{
                        department{
                            id
                            name
                        }
                        id
                        isActive
                        name
                    }
                    slaCreateByEod
                }
                errors {
                    property
                    description
                  }
        }
    }
`;

export const DELETE_CATEGORY = `
    mutation DeleteCategory($id: ID!) {
        deleteCategory(id: $id) {
            result
            errors {
                property
                description
              }
        }
    }
    `;

export const DELETE_SUBCATEGORY = `
    mutation DeleteSubCategory($id: ID!) {
        deleteSubCategory(id: $id) {
            result
            errors {
                property
                description
              }
        }
    }
    `;

export const GET_CATEGORY = `
    query Category($id: ID!) {
        category(id: $id) {
                department{
                    id
                    name
                }
                id
                isActive
                name
                subCategories {   
                name
                sla
                id
                isActive
                }
            }
    }
`;

export const GET_SUBCATEGORY = `
    query SubCategory($id: ID!) {
        subCategory(id: $id) {
            id
            isActive
            autoCloseable
            longName
            name
            sla
            category{
                department{
                    id
                    name
                }
                id
                isActive
                name
            }
            slaCreateByEod
            }
    }
`;
